import MorrisonsSamlContainer from "../containers/Morrisons"

export default {
  morrisons: MorrisonsSamlContainer
}
